/* C248 (Justin 2026-09-21): keeps the blank-apparel free-shipping card on a product page in step with the cart.
 *
 * The card is rendered server side by snippets/np-blanks-freeship.liquid, so it is correct when the page loads and stale the
 * moment someone adds a hat without navigating. This recomputes the blanks subtotal from /cart.js and rewrites the card.
 *
 * It can do that with no Section Rendering round trip because `vendor` rides on cart.js line items — product TAGS do not, which
 * is why detection is by vendor in the first place. Same rule as the snippet: vendor 'Ninja Transfers' is exactly this store's
 * Collective blanks.
 *
 * Trigger is a MutationObserver on the header cart count, because every add path in this theme updates that badge, whatever
 * event it does or does not dispatch. The cart events are listened for too, belt and braces.
 */
(function () {
  'use strict';
  if (window.__npBlanksFreeship) return;
  window.__npBlanksFreeship = true;

  var VENDOR = 'Ninja Transfers';

  function card() { return document.querySelector('[data-np-bfs]'); }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function paint(total) {
    var el = card();
    if (!el) return;
    var host = el.querySelector('free-shipping-blanks');
    var text = el.querySelector('[data-np-bfs-text]');
    if (!host || !text) return;

    var goal = parseInt(host.getAttribute('free-shipping-amount'), 10) || 5900;
    host.setAttribute('data-cart-total', String(total));

    var remaining = goal - total;
    /* C343: the card layout (label + "Add $X for free shipping"); the old one-line copy is kept for any cached markup */
    var isCard = el.classList.contains('np-bfs--card');
    if (remaining > 0) {
      text.innerHTML = isCard
        ? 'Add <span class="np-bfs__amt">' + money(remaining) + '</span> for <strong>free shipping</strong>'
        : 'Add <strong>' + money(remaining) + '</strong> for free shipping on blanks';
      el.classList.remove('np-bfs--met');
    } else {
      text.innerHTML = isCard ? '<strong>Free shipping unlocked</strong>' : '<strong>Free shipping unlocked</strong> on blanks';
      el.classList.add('np-bfs--met');
    }

    /* the cart's card only exists while the cart holds blanks; a product page's card (data-np-bfs-always) always shows */
    el.hidden = total <= 0 && !el.hasAttribute('data-np-bfs-always');

    /* C343: set the width ourselves every time — on product pages the theme painter ran but left the bar at 0 — and still
       call the painter so the cart page keeps its own behaviour */
    try {
      var bar = el.querySelector('.cart-notice__slider-bar');
      if (bar) bar.style.width = Math.min(100, (total / goal) * 100) + '%';
      if (typeof window.reCalculateFreeShippingModule__recall === 'function') window.reCalculateFreeShippingModule__recall();
      if (bar) bar.style.width = Math.min(100, (total / goal) * 100) + '%';
    } catch (e) {}
  }

  var busy = false;
  function sync() {
    if (busy || !card()) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = 0;
        (cart.items || []).forEach(function (it) {
          if (it.vendor === VENDOR) total += it.final_line_price;
        });
        paint(total);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function start() {
    if (!card()) return;
    ['cart:refresh', 'cart-updated', 'cart:updated', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(sync, 250); });
    });
    var badge = document.querySelector('[data-header-cart-count]');
    if (badge && window.MutationObserver) {
      new MutationObserver(function () { setTimeout(sync, 250); })
        .observe(badge, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-count'] });
    }
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
